import React from "react";

import { listingTypes } from "../../constants";
import ViewTypesIconMapping from "../../assets/icons/ViewTypesIconMapping";
import {
  formatDate,
  getLabelsByIds,
  unixTimestampToDate,
  numberFormatting,
} from "../../shared/utility";
import CustomSvg from "../../shared/components/custom-svg/CustomSvg";

const PropertyDescription = ({
  description,
  depositRequired,
  availability,
  listingType,
  currencyCode,
  property,
}) => {
  return (
    <div className="property-description-wrapper">
      <div className="row w-100">
        <div className="col-12 col-lg-8 col-xl-9">
          <div className="property-description">
            <h2>Description</h2>
            <div className="row pb-2">
              <div className="col-12 col-md-6 col-xl-4">
                <div className="d-flex gap-2 align-items-center">
                  <div className="description-item-heading">Listing Type:</div>
                  <div className="description-item-value">
                    {getLabelsByIds(listingTypes, listingType, "label")}
                  </div>
                </div>
              </div>
              <div className="col-12 col-md-6 col-xl-4">
                <div className="d-flex gap-2 align-items-center">
                  <div className="description-item-heading">Availability:</div>
                  <div className="description-item-value">
                    {formatDate(unixTimestampToDate(availability))}
                  </div>
                </div>
              </div>
              <div className="col-12 col-md-6 col-xl-4">
                <div className="d-flex gap-2 align-items-center">
                  <div className="description-item-heading">Built in Year:</div>
                  <div className="description-item-value">
                    {property?.amenity?.builtInYear || "N/A"}
                  </div>
                </div>
              </div>
            </div>
            <div className="d-flex align-items-center gap-4">
              <div className="description-item-heading mt-1">View Type:</div>
              <div className="row w-100">
                {property?.viewType?.map((type) => (
                  <div className="col-12 col-sm-12 col-md-6 col-xl-4 mt-2">
                    <div className="d-flex align-items-center gap-2 gap-lg-3">
                      <CustomSvg
                        className="property-detail-view-type-icon"
                        src={ViewTypesIconMapping[type.icon]}
                      />
                      <div className="property-icon-text" title={type.title}>
                        {type.title}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
        <div className="divider-line d-none d-lg-block"></div>
        <div className="col-12 col-lg-4 col-xl-3">
          <div className="deposit-info">
            <h2>Deposit Calculator</h2>
            <div className="deposit-details">
              <p>Deposit Required</p>
              <p>
                <div className="d-flex align-items-center gap-1">
                  <div>{currencyCode}</div>
                  <div>{numberFormatting(depositRequired)}</div>
                </div>
              </p>
            </div>
            {property?.openHouse && (
              <div>
                <div className="open-house-heading">House Viewing Date:</div>
                <div className="description-item-value">
                  {`${formatDate(
                    unixTimestampToDate(property?.startDate)
                  )} to ${formatDate(unixTimestampToDate(property?.endDate))}`}
                </div>
              </div>
            )}
          </div>
        </div>
        <div className="col-12">
          <div className="property-description">
            <p className="text-pre-wrap">{description}</p>
          </div>
        </div>
        {/* <div className="col-12">
          <div className="d-flex gap-2 align-items-center">
            <div className="description-item-heading">Built in Year:</div>
            <div className="description-item-value">
              {property?.amenity?.builtInYear || "N/A"}
            </div>
          </div>
        </div> */}
      </div>
    </div>
  );
};

export default PropertyDescription;
